import React from 'react';
import LoadMoreBtn from './load_more_btn/LoadMoreBtn';
import ReviewsItems from './reviews_items/ReviewsItems';
import './reviews-list.scss';

class ReviewsList extends React.Component {

    genKey(index, raterUsername) {
        return `${index}-${raterUsername}`;
    }

    render() {
        const {
            ps,
            stars,
            type,
            fetchReviews,
            lastStar,
            showLoadMore,
            gigId
        } = this.props;

        // no reviews
        if (!stars || stars.size === 0) {
            return null;
        }

        return (
            <div className="review-list">
                <ul>
                    {stars.map((review, index) =>
                        <ReviewsItems key={this.genKey(index, review.get('rater_username'))} review={review} ps={ps} gigId={gigId}/>
                    )}
                </ul>
                {showLoadMore && <LoadMoreBtn fetchReviews={fetchReviews}
                    type={type}
                    lastStar={lastStar}/>}
            </div>
        );
    }
}

export default ReviewsList;



// WEBPACK FOOTER //
// ./src/reviews/reviews_list/ReviewsList.js